import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  exportFlag: null,
};

export const appSlice = createSlice({
  name: "APP",
  initialState,
  reducers: {
    ADD_EXPORT_FLAG: (state, action) => {
      state.exportFlag = action.payload;
    },
  },
});

export const { ADD_EXPORT_FLAG } = appSlice.actions;
export default appSlice.reducer;
